import { useAreaProfiling } from '@bvt-features/danone/area-profiling/hooks/useAreaProfiling';
import { useEffect } from 'react';

export default function DownloadProvider() {
  const danone = useAreaProfiling();

  const triggerDownload = (url, filename) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    // check session storage for download status
    if (
      danone.state.status_DOWNLOAD_VILLAGE === 'SUCCESS' &&
      sessionStorage.getItem('danone_village') === 'true'
    ) {
      triggerDownload(
        danone.state.download.village_url,
        danone.state.download.village_filename || 'test_village.xlsx'
      );
      sessionStorage.removeItem('danone_village');
    }
  }, [danone.state.status_DOWNLOAD_VILLAGE]);

  useEffect(() => {
    // check session storage for download status
    if (
      danone.state.status_DOWNLOAD_CATCHMENT === 'SUCCESS' &&
      sessionStorage.getItem('danone_catchment') === 'true'
    ) {
      triggerDownload(
        danone.state.download.catchment_url,
        danone.state.download.catchment_filename || 'test_catchment.xlsx'
      );
      sessionStorage.removeItem('danone_catchment');
    }
  }, [danone.state.status_DOWNLOAD_CATCHMENT]);
  return null;
}
